import React from "react";
import { awards } from "../../data/mock";
import { getIcon } from "../../data/iconMap";
import Reveal from "../ui-custom/Reveal";

const AwardsStrip = () => {
  return (
    <section className="relative py-16 md:py-20 px-6 border-y border-border/5 bg-white/[0.015]">
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <p className="section-eyebrow text-center mb-10">Certifications &amp; Accolades</p>
        </Reveal>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {awards.map((a, i) => {
            const Icon = getIcon(a.icon);
            return (
              <Reveal key={a.title} delay={i * 0.06} className="flex flex-col items-center text-center gap-3">
                <Icon size={26} className="text-qamber" />
                <div>
                  <p className="text-foreground font-display font-semibold text-sm">{a.title}</p>
                  <p className="text-[11px] text-muted-foreground mt-1 leading-snug">{a.subtitle}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AwardsStrip;
